






import * as moment from "moment";
import { staticContent } from "../../localisation/detect-lang";
import { isRTL } from "../../helpers";
export default Vue.component("restaurant-status", {
data() {
  return {
    staticContent,
    durationText: null,
    todayWorkingHours: [],
    tomorrowWorkingHours: [],
    currentTime: null,
  };
},

mounted() {
  this.currentTime = moment();
  this.durationText = this.restaurantOpenCloseDuration();
},
computed: {
  restaurantInfo() {
    return this.$root.restaurantPage.restHeaderObj;
  },
},

methods: {
  restaurantOpenCloseDuration() {
    if (this.restaurantInfo.openNow) {
      return this.getClosesInMins(); 
    }
    return this.getOpenTime();
  },
  getDuration(time: moment.Moment, returnValue: "minutes" | "openingTime") {
    const currentTime = moment();
    const openingTime = time.locale(isRTL ? "ar-ly" : "en").fromNow(true);

    if (returnValue === "openingTime") {
      return openingTime;
    }

    const duration = moment.duration(time.diff(currentTime));
    const minutes = Math.round(duration.asMinutes());
    return minutes;
  },

  getClosesInMins() {
    const currentTimeInSecs = moment(Date.now() / 1000); // to convert it to seconds
    const secondsUntilClose= moment(this.restaurantInfo.secondsUntilClose);
    const remainingMins = moment.duration(secondsUntilClose.diff(currentTimeInSecs)).asMinutes();

    if (remainingMins <= 30 && remainingMins > 0) {
      return `${staticContent.common.closesIn} ${remainingMins} ${
        staticContent.common.minutes
      }`;
    }
    return null;
  },
  getOpenTime() {
    const currentDay = moment().format('dddd').toLowerCase();
    const currentDayData= this.restaurantInfo.deliveryHours[currentDay];

      if (currentDayData.length > 1) {
        const currentTimeInSecs = Date.now() / 1000; // to convert it to seconds

        const deliveryHoursEnd = currentDayData[currentDayData.length -1].to;

        // if current time in seconds is less than the the last object in current day data this means it in gap hours
        if (deliveryHoursEnd && deliveryHoursEnd > currentTimeInSecs) {
          const gapEndTime = moment(deliveryHoursEnd).format("HH:mm:ss a");
          const remainingTime = this.getDuration(gapEndTime, "openingTime");
          return `${staticContent.common.openingIn} ${remainingTime}`;

        }
      }
    const timeUntilOpened = moment(this.restaurantInfo.secondsUntilOpen, "HH:mm:ss a");
    const formattedTime = timeUntilOpened
        .locale(isRTL ? "ar-ly" : "en")
        .format("hh:mm A");
    return `${staticContent.common.opensTomorrow} ${formattedTime}`;
  },
},
});
